import { Component, input, signal, effect } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { ProductService } from '../../../../services/product.service';

@Component({
	selector: 'app-product-dropdown-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './product-dropdown-field.component.html',
	styleUrl: './product-dropdown-field.component.scss',
})
export class ProductDropdownFieldComponent extends BaseFieldComponent {
	// Input as signal
	readonly multiple = input<boolean>(false);

	// Reactive options
	readonly options = signal<DropdownOption[]>([]);

	public static override validators: ValidatorFn[] = [Validators.required];

	constructor(private productService: ProductService) {
		super();

		// Load products once on init (no dependencies → no need for effect)
		this.productService.getProducts$().then(products => {
			this.options.set(
				products.map(product => ({
					value: product.name,
					label: product.name,
				}))
			);
		});
	}
}
